__turbopack_context__.v({
  "alertBrand": "WIFgya_alertBrand",
  "bannerSub": "WIFgya_bannerSub",
  "bannerTitle": "WIFgya_bannerTitle",
  "brandSurface": "WIFgya_brandSurface",
  "condensed": "WIFgya_condensed",
  "ctaGroup": "WIFgya_ctaGroup",
  "footer": "WIFgya_footer",
  "inlineDoor": "WIFgya_inlineDoor",
  "oneLine": "WIFgya_oneLine",
  "pendingSlot": "WIFgya_pendingSlot",
  "pinned": "WIFgya_pinned",
  "pitch": "WIFgya_pitch",
  "signedOut": "WIFgya_signedOut",
  "slot": "WIFgya_slot",
  "valueBullets": "WIFgya_valueBullets",
});
